// import React from 'react'
import {motion} from 'framer-motion'
// import { Link } from 'react-router-dom'
import React, { useEffect } from 'react'
import { Link } from "react-scroll";
// import NavbarA from './NavbarA';
import NavbarS from './NavbarS';
import NavbarCookie from './NavbarCookie';
import Footer from './Footer';


const CookiePage = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return (
    <div id='main'>
        <NavbarCookie/>
        <div className='container cookie-content'>
            <h3 style={{textAlign: 'center',paddingBottom: '1em'}}><b>Cookie Policy</b></h3>
            <h4>What is a cookie?</h4>
            <p>A cookie is a small data file stored on your computer or mobile device at the request to your browser from a website when you visit this website. The cookie allows the website to “remember” your actions or preference for a certain period of time.</p>
            <p>Most browsers allow cookies. However, user can set your browsers to refuse or remove them, if they wish.</p>
            <p>Some cookies are deleted when you close your browser. They are known as session cookies. Others remain on your device until they expire or until you delete them from your cache. They are called permanent cookies and enable certain information about your use to be recalled when you return to the website.</p>
            <p>A cookie can temporarily store anonymous information about the use and users of a website.</p>
            <p>Some cookies are required in order to use a website, others allow customization and optimization of the displayed content, the collection of user preferences or the monitoring of the website’s audience, website errors and the securing of its access.</p>
            <h4>The use of cookies when you visit our website</h4>
            <p>Cookies allow us to store information on the server to help make the Web experience better for you and for web site performance review.</p>
            <h4>How to control cookies?</h4>
            <p>If you don't want to receive cookies, you can modify your browser so that it notifies you when cookies are sent to it or you can refuse cookies altogether. You can also delete cookies that have already been set. If you wish to restrict or block web browser cookies which are set on your device then you can do this through your browser settings.</p>
            <p>We draw your attention to the fact that disabling cookies may prevent you from accessing certain features on our websites</p>
        </div>
        <Footer/>
        {/* <footer className='FooterStyle' style={{backgroundColor: "rgb(8, 24, 34)", padding: "3em 0"}}>
            <div style={{ width: '90%', margin: '0 auto'}}>
             <p style={{color: '#fff', fontSize: '14px', textAlign: 'center'}}>Copyright © 2022 AlphaXN. All rights reserved.</p>
            </div>
        </footer> */}
    </div>
  )
}

export default CookiePage